/**
 * Match backend/utils/appointment-visit-window.js — IST wall clock + UTC calendar day on appointmentDate.
 */

const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000;

function utcMsFromIstWallClock(year, month1Based, day, hour, minute) {
  return Date.UTC(year, month1Based - 1, day, hour, minute, 0, 0) - IST_OFFSET_MS;
}

function normalizeBookingSlotKeyPart(value) {
  return String(value || "")
    .trim()
    .replace(/\p{Cf}/gu, "")
    .replace(/\s+/g, " ")
    .replace(/[\u00B7\u2022\u2219\u2024\u2981\u30FB\u2027]/g, "\u00B7");
}

function parseTimeSlotDisplay(timeSlotDisplay) {
  const raw = normalizeBookingSlotKeyPart(timeSlotDisplay);
  if (!raw) return { timePart: "", clinicLabel: "" };
  const parts = raw.split("\u00B7").map((p) => p.trim()).filter(Boolean);
  if (parts.length >= 2) {
    return { timePart: parts[0], clinicLabel: parts.slice(1).join(" · ").trim() };
  }
  return { timePart: raw, clinicLabel: "" };
}

function parseClockToHourMinute(timePart) {
  const s = String(timePart || "").trim();
  if (!s) return null;
  const m12 = s.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)\s*$/i);
  if (m12) {
    let h = parseInt(m12[1], 10);
    const mi = parseInt(m12[2], 10);
    const ap = m12[3].toUpperCase();
    if (ap === "PM" && h !== 12) h += 12;
    if (ap === "AM" && h === 12) h = 0;
    if (!Number.isFinite(h) || !Number.isFinite(mi) || h < 0 || h > 23 || mi < 0 || mi > 59) return null;
    return { hour: h, minute: mi };
  }
  const m24 = s.match(/^(\d{1,2}):(\d{2})$/);
  if (m24) {
    const h = parseInt(m24[1], 10);
    const mi = parseInt(m24[2], 10);
    if (!Number.isFinite(h) || !Number.isFinite(mi) || h < 0 || h > 23 || mi < 0 || mi > 59) return null;
    return { hour: h, minute: mi };
  }
  return null;
}

function appointmentVisitSlotEndUtcMs(appointmentDate, timeSlotDisplay) {
  const d = new Date(appointmentDate);
  if (!Number.isFinite(d.getTime())) return null;
  const y = d.getUTCFullYear();
  const mo = d.getUTCMonth() + 1;
  const day = d.getUTCDate();
  const { timePart } = parseTimeSlotDisplay(timeSlotDisplay);
  const hm = parseClockToHourMinute(timePart);
  if (!hm) {
    return utcMsFromIstWallClock(y, mo, day, 23, 59) + 60 * 1000;
  }
  const start = utcMsFromIstWallClock(y, mo, day, hm.hour, hm.minute);
  return start + 60 * 60 * 1000;
}

export function isAppointmentVisitWindowOver(appointmentDate, timeSlotDisplay) {
  const end = appointmentVisitSlotEndUtcMs(appointmentDate, timeSlotDisplay);
  if (end == null) return false;
  return Date.now() >= end;
}
